import { useMemo } from 'react';
import {
  useFlag as useUnleashFlag,
  useVariant,
  useFlagsStatus,
} from '@unleash/proxy-client-react';

type UseFlagArgs = {
  name: string;
};

export const useFlag = ({ name }: UseFlagArgs) => {
  const enabled = useUnleashFlag(name);
  const variant = useVariant(name);
  const { flagsReady, flagsError } = useFlagsStatus();
  return useMemo(
    () => ({
      enabled,
      variant,
      flagsReady,
      flagsError,
    }),
    [enabled, variant, flagsReady, flagsError]
  );
};

type Props = UseFlagArgs & {
  children: (args: ReturnType<typeof useFlag>) => JSX.Element;
};

export const Flag = ({ name, children }: Props) => {
  const args = useFlag({ name });
  return children(args);
};
